import { render, staticRenderFns } from "./PolyIntegerReferenceCardIndex.vue?vue&type=template&id=31133b55&"
import script from "./PolyIntegerReferenceCardIndex.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceCardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports